import React from "react";
import Box from "@mui/material/Box";
import {
  Divider,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PlayerCardRow from "../PlayerCardRow";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CDB", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export const AFL_EVENT_COLORS: { [id: string]: string } = {
  "Groundout": "#BDBDBD",
  "Single": "#008000",
  "Double": "#0000FF",
  "Home Run": "#f7eb11",
  "GIDP": "#BDBDBD",
  "Lineout": "#BDBDBD",
  "Flyout": "#BDBDBD",
  "Field Error": "#BDBDBD",
  sac_fly: "#BDBDBD",
  sac_bunt: "#BDBDBD",
  "Triple": "#f42f11",
  double_play: "#BDBDBD",
  fielders_choice_out: "#BDBDBD",
  fielders_choice: "#BDBDBD",
};

export default function AflHitterPercentiles(props: any) {
  console.log(props)
  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }


  // Get team colors for styling
  const teamColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][0]
    : teamColors["FA"][0];

  const textColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][1]
    : teamColors["FA"][1];

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "475px" : "100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor: teamColor,
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color: textColor,
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    AFL Pitching Percentiles
                  </span>
                </Typography>
              </Grid>
            </div>
            <div>
              <div
                style={{ margin: "auto", width: "475px", maxWidth: "90vw" }}
              >
              <Typography
                variant="h6"
                sx={{
                  marginTop: "5px",
                  marginBottom: "5px",
                  color: "rgba(0, 0, 0, 0.4)",
                  fontWeight: 600,
                  fontSize: "0.5rem",
                  pointerEvents: "none",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  letterSpacing: "0.5em", // tweak this value until it fills ~80%
                }}
              >
                ProspectSavant.com/afl/player/{props.playerDataProp.id}
              </Typography>
              <PlayerCardRow
                stat="psStuff+"
                value={props.playerDataProp.weighted_psStuff.toFixed(1) }
                percentile={props.playerDataProp?.weighted_psStuff_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.weighted_psStuff_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Max Velo"
                value={props.playerDataProp.max_velo.toFixed(1) + (props.isDesktop ? " mph" : "")}
                percentile={props.playerDataProp?.max_velo_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.max_velo_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="wOBA"
                value={props.playerDataProp.woba.toFixed(3)}
                percentile={props.playerDataProp?.woba_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.woba_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="K%"
                value={(props.playerDataProp.k_percent*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.k_percent_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.k_percent_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Whiff%"
                value={(props.playerDataProp.whiff_rate*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.whiff_rate_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.whiff_rate_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="BB%"
                value={(props.playerDataProp.bb_percent*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.bb_percent_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.bb_percent_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              
              <PlayerCardRow
                stat="EV"
                value={props.playerDataProp.ev.toFixed(1) + (props.isDesktop ? " mph" : "")}
                percentile={props.playerDataProp?.ev_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.ev_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Barrel%"
                value={(props.playerDataProp.barrel_rate*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.barrel_rate_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.barrel_rate_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Hard Hit%"
                value={(props.playerDataProp.hard_hit_rate*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.hard_hit_rate_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.hard_hit_rate_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="SwStr%"
                value={(props.playerDataProp.swinging_strike_rate*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.swinging_strike_rate_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.swinging_strike_rate_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Chase%"
                value={(props.playerDataProp.chase_rate*100).toFixed(1)+"%"}
                percentile={props.playerDataProp?.chase_rate_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.chase_rate_p}
                isDesktop={props.isDesktop}
              />
              <Divider variant="middle" />
              <PlayerCardRow
                stat="Extension%"
                value={(props.playerDataProp.extension.toFixed(2))+ (props.isDesktop ? " ft" : "")}
                percentile={props.playerDataProp?.extension_p.toFixed(2) * 100}
                percentile_raw={props.playerDataProp?.extension_p}
                isDesktop={props.isDesktop}
              />
              
            </div>
          </div>

        </Box>
      </Grid>
    </Grid>
    </div >
  );
}